/**
 * Class name prefix for @tvg/fuse components in this fragment.
 * Must match the prefix used in webpack's postcss-prefixer config.
 */
export const FUSE_CLASS_PREFIX = "seoMetadata_";
